export default class CbCenterItem {
    label: string = '';
    icon: string = '';
    isSelected: boolean = false;
    id: number = 0;
}